import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../../graphql/types.generated';
export type GetBookingDocumentsQueryVariables = GraphQLTypes.Exact<{
  zencargoReference: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetBookingDocumentsQueryResult = { __typename?: 'Query' } & {
  bookings: { __typename?: 'BookingConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        GraphQLTypes.Maybe<
          { __typename?: 'Booking' } & Pick<GraphQLTypes.Booking, 'zencargoReference'> & {
              bookingDocuments: Array<
                { __typename?: 'BookingDocument' } & Pick<
                  GraphQLTypes.BookingDocument,
                  'actionItemDocument' | 'assetUrl' | 'description' | 'documentType' | 'error' | 'id' | 'state' | 'uploadedBy'
                > & {
                    createdAt: { __typename?: 'RichDateTime' } & Pick<GraphQLTypes.RichDateTime, 'dateTime'>;
                    permissions: { __typename?: 'Permissions' } & Pick<
                      GraphQLTypes.Permissions,
                      'agentForwarder' | 'customerUser' | 'manufacturer'
                    >;
                  }
              >;
            }
        >
      >
    >;
  };
};

export const GetBookingDocumentsDocument = gql`
  query getBookingDocuments($zencargoReference: String!) {
    bookings(zencargoReferences: [$zencargoReference]) {
      nodes {
        bookingDocuments {
          actionItemDocument
          assetUrl
          createdAt {
            dateTime
          }
          description
          documentType
          error
          id
          permissions {
            agentForwarder
            customerUser
            manufacturer
          }
          state
          uploadedBy
        }
        zencargoReference
      }
    }
  }
`;
